import React from "react";
import ContentLoader from "react-content-loader";

function CategoryLoading() {
  return (
    <ContentLoader
      speed={2} // 속도
      // width={530}
      // height={180}
      viewBox="0 0 500 640"
      backgroundColor="#27292d" // 배경색
      foregroundColor="#4b4b4b" // 요소 색
    >
      <circle cx="50" cy="65" r="30" />
      <rect x="100" y="30" rx="20" ry="20" width="370" height="70" />

      <circle cx="50" cy="165" r="30" />
      <rect x="100" y="130" rx="20" ry="20" width="370" height="70" />

      <circle cx="50" cy="265" r="30" />
      <rect x="100" y="230" rx="20" ry="20" width="370" height="70" />

      <circle cx="50" cy="365" r="30" />
      <rect x="100" y="330" rx="20" ry="20" width="370" height="70" />

      <circle cx="50" cy="465" r="30" />
      <rect x="100" y="430" rx="20" ry="20" width="370" height="70" />

      <circle cx="50" cy="565" r="30" />
      <rect x="100" y="530" rx="20" ry="20" width="370" height="70" />
    </ContentLoader>
  );
}

export default CategoryLoading;
